import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthServiceService } from '../../service/auth-service.service';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css'
})
export class SpinnerComponent {
  isLoading = false;
  cgBusyPromises=false;

 constructor(private spinnerService: AuthServiceService,public router:Router){
  
  this.spinnerService.spinner$.subscribe((value: boolean) => {
    this.isLoading = value;
    this.cgBusyPromises =value;
  });
 }


}







